<script>
  import {media} from 'svelte-match-media'
  import ViewSource from '../components/ViewSource.svelte'
  import ChartDotKey from '../svgs/ChartDotKey.svelte'
</script>

<div class="chart">
  <h4 class="title">Am I hitting my reach and frequency goals? Which CTV partners are most efficient?</h4>

  {#if $media.mobile}
    <svg width="343" height="200" viewBox="0 0 343 200" xmlns="http://www.w3.org/2000/svg">
      <g class="gray-line">
        <line x1="29" y1="21.5" x2="343" y2="21.5"/>
        <line x1="29" y1="69.5" x2="343" y2="69.5"/>
        <line x1="29" y1="117.5" x2="343" y2="117.5"/>
        <line x1="29" y1="165.5" x2="343" y2="165.5"/>
      </g>
      <rect x="111" y="116" width="24" height="49" class="gray"/>
      <rect x="135" y="156" width="24" height="9" class="red"/>
      <rect x="159" y="152" width="24" height="13" class="white"/>
      <rect x="33" y="37" width="24" height="129" class="gray"/>
      <rect x="57" y="146" width="24" height="20" class="red"/>
      <rect x="81" y="158" width="24" height="8" class="white"/>
      <rect x="189" y="136" width="24" height="29" class="gray"/>
      <path d="M72 145.5L145 127.5L228.5 151.5L303 18" fill="none" stroke="white" stroke-width="1.4" stroke-miterlimit="16" stroke-linecap="round" stroke-dasharray="1 3"/>
      <rect x="213" y="152" width="24" height="13" class="red"/>
      <rect x="237" y="156" width="24" height="9" class="white"/>
      <rect x="267" y="140" width="24" height="25" class="gray"/>
      <rect x="291" y="161" width="24" height="4" class="red"/>
      <rect x="315" y="145" width="24" height="20" class="white"/>
      <g class="white tiny">
        <text><tspan x="60.9541" y="139.735">4.8</tspan></text>
        <text><tspan x="217.652" y="143.735">2.7</tspan></text>
        <text><tspan x="294.157" y="11.735">12.0</tspan></text>
        <text><tspan x="82.3115" y="152.735">$0.11</tspan></text>
        <text><tspan x="158.379" y="146.735">$0.15</tspan></text>
        <text><tspan x="234.758" y="150.735">$0.08</tspan></text>
        <text><tspan x="313.036" y="139.735">$0.29&#10;</tspan></text>
        <text><tspan x="139.11" y="121.735">5.9</tspan></text>
      </g>
      <g class="gray bold small">
        <text><tspan x="0" y="24.632">60M</tspan></text>
        <text><tspan x="0" y="73.632">40M</tspan></text>
        <text><tspan x="0" y="120.632">20M</tspan></text>
        <text><tspan x="0" y="168.632">0</tspan></text>
      </g>
      <g class="white bold small">
        <text><tspan x="37" y="184.632">Network A</tspan></text>
        <text><tspan x="116" y="184.632">Network B</tspan></text>
        <text><tspan x="194" y="184.632">Network C</tspan></text>
        <text><tspan x="272" y="184.632">Network D</tspan></text>
      </g>
    </svg>
  {:else}
  <svg width="597" height="253" viewBox="0 0 597 253" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g class="gray-line">
      <line x1="52.1023" y1="33.7458" x2="583.761" y2="33.7458"/>
      <line x1="52.1023" y1="95.3733" x2="583.761" y2="95.3733"/>
      <line x1="52.1023" y1="157" x2="583.761" y2="157"/>
      <line x1="52.1023" y1="217.628" x2="583.761" y2="217.628"/>
    </g>
    <rect x="59" y="51" width="40" height="166" class="gray"/>
    <rect x="99" y="191" width="40" height="26" class="red"/>
    <rect x="139" y="206" width="40" height="11" class="white"/>
    <rect x="198" y="154" width="40" height="63" class="gray"/>
    <rect x="238" y="205" width="40" height="12" class="red"/>
    <rect x="278" y="200" width="40" height="17" class="white"/>
    <rect x="337" y="179" width="40" height="38" class="gray"/>
    <rect x="377" y="200" width="40" height="17" class="red"/>
    <rect x="417" y="205" width="40" height="12" class="white"/>
    <rect x="476" y="185" width="40" height="32" class="gray"/>
    <rect x="516" y="211" width="40" height="6" class="red"/>
    <rect x="556" y="191" width="40" height="26" class="white"/>
    <path d="M117.909 189.808L257 166.698L396.5 197.512L535.5 24" stroke="white" stroke-width="1.4" stroke-miterlimit="16" stroke-linecap="round" stroke-dasharray="1 3"/>
    <g class="white large">
      <text><tspan x="106.739" y="181.076">4.8</tspan></text>
      <text><tspan x="385.875" y="188.211">2.7</tspan></text>
      <text><tspan x="520.636" y="13.736">12.0</tspan></text>
      <text><tspan x="143.068" y="200.767">$0.11</tspan></text>
      <text><tspan x="278.443" y="192.063">$0.15</tspan></text>
      <text><tspan x="416.511" y="197.199">$0.08</tspan></text>
      <text><tspan x="554.58" y="183.076">$0.29</tspan></text>
      <text><tspan x="245.807" y="157.965">5.9</tspan></text>
    </g>
    <g class="gray bold">
      <text><tspan x="0" y="40.3268">60M</tspan></text>
      <text><tspan x="0" y="104.238">40M</tspan></text>
      <text><tspan x="0" y="160.582">20M</tspan></text>
      <text><tspan x="0" y="216.209">0</tspan></text>
    </g>
    <g class="white bold large">
      <text><tspan x="81" y="248.876">Network A</tspan></text>
      <text><tspan x="220" y="248.876">Network B</tspan></text>
      <text><tspan x="359" y="248.876">Network C</tspan></text>
      <text><tspan x="498" y="248.876">Network D</tspan></text>
    </g>
    </svg>
    
  {/if}
  
  <div class="key">
    <div class="key1 item"><div class="block"></div><p class="name">Impressions</p></div>
    <div class="key2 item"><div class="block"></div><p class="name">Household Reach</p></div>
    <div class="key3 item"><div class="block"></div><p class="name">Cost Per Unique</p></div>
    <div class="key4 item"><ChartDotKey /><p class="name">Average Frequency</p></div>
  </div>
  <ViewSource id="reach_and_frequency">Internal data, Aug 2020.</ViewSource>
  <p class="takeaway accent"><strong>Key takeaway:</strong></p>
  <ul>
    <li><p>Network C is your most efficient partner and Network’s B and D are least efficient. Buy more of Network C in the scatter market.</p></li>
  </ul>
</div>

<style>
  .title {
    margin: 0 0 40px;
  }

  svg text {
    font-family: inherit;
    white-space: pre;
    font-size: 14px;
    font-weight: 500;
  }
  .white {
    fill: white;
  }
  .gray {
    fill: var(--gray-link);
  }
  .gray-line {
    stroke: var(--gray-line);
  }
  .bold text {
    font-weight: bold;
  }
  .large text {
    font-size: 16px;
  }
  .small text {
    font-size: 12px;
  }
  .tiny text {
    font-size: 10px;
  }
  .red {
    fill: var(--verizon-red)
  }
  .key {
    display: flex;
    flex-wrap: wrap;
    font-weight: 500;
    font-size: 12px;
    margin: 10px -8px -5px -8px;
  }
  .key .name {
    margin: 0;
  }
  .key .item {
    display: flex;
    padding: 8px;
    white-space: nowrap;
  }
  .key .block {
    width: 12px;
    height: 12px;
    margin-right: 8px;
    transform: translateY(1.5px)
  }
  .key1 .block {
    background: var(--gray-link)
  }
  .key2 .block {
    background: var(--verizon-red)
  }
  .key3 .block {
    background: white;
  }
  .key4 {
    align-items: center;
  }
  .key4 :global(svg) {
    margin-right: 8px;
  }
  @media(min-width: 768px) {
    svg {
      width: 100%;
      height: auto;
    }
    .key {
      margin-top: 24px;
    }
  }
</style>